import { getAPIClient } from '@/lib/api';

export const registerStockNotification = async ({
  lang,
  country,
  token,
  sku,
  email,
  url
}: {
  lang: string;
  country: string;
  token: string;
  sku: string;
  email: string;
  url: string;
}): Promise<any> => {
  const apiClient = getAPIClient({ country });

  const config = {
    headers: {
      ['UYN-LANGUAGE']: lang,
      ['UYN-COUNTRY']: country,
      ['UYN-BEARER']: token
    }
  };

  try {
    const response = await apiClient.post(
      '/wp-json/uyn/v1/restock',
      {
        sku,
        email,
        url
      },
      config
    );

    return response;
  } catch (error) {
    return { error };
  }
};
